import styled from 'styled-components';

export const RefreshButton = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Description = styled.p`
  &&& {
    text-align: center;

    font-family: Inter;
    font-size: 13px;
    font-weight: 600;
    line-height: 18.2px;

    text-align: center;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.noGamesDescription};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px 0 32px;
`;

export const Hint = styled.div`
  color: ${({ theme }) => theme.noGamesDescription};
  text-align: center;

  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;
